import React, { useEffect } from 'react';
import { Box, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import tPaths from '../../utils/tPaths';
import useStyles from './EmailVerification.styles';
import RedbullLogoIcon from '../../assets/images/redbullIcon/RedBullLogoIcon';

const NonAppEmailVerification = () => {
    const styles = useStyles();

    const { t } = useTranslation();

    const searchParams = new URLSearchParams(document.location.search)
    const redirectUrl = searchParams.get('url');
    const verificationToken = searchParams.get('token');

    const changeDocumentTitle = (title: string) => {
        document.title = title;
    };

    useEffect(() => {

        if (redirectUrl) window.location.href = redirectUrl as string;

        if (verificationToken) {
            window.location.href = `rbm-data://${window.location.host}/completeRegistration?token=${verificationToken}`;
        }

        changeDocumentTitle('WNDR email verification');

        return () => changeDocumentTitle('WNDR email verification');
    }, []);

    return (
        <Box className={styles.background}>
            <Box className={styles.emailVerificationForm}>
                <Box className={styles.inputContainer}>
                    <Box alignSelf="center" margin={1} py={1}>
                        <RedbullLogoIcon />
                    </Box>
                    <Typography variant="h5" className={styles.subtitle}>
                        {t(tPaths.global.nonAppEmailEmailVerification)}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default NonAppEmailVerification;
